import { type FC, memo } from 'react';
import { GroupedLinesBySport } from './components/GroupedLinesBySport/GroupedLinesBySport';
import { GroupedLinesSport } from './components/GroupedLinesSport/GroupedLinesSport';
import type { GroupedLinesProps } from './GroupedLines.types';
const BaseGroupedLines: FC<GroupedLinesProps> = ({
  variant = 'TRADITIONAL',
  ...rest
}) => {
  if (['CYBER', 'OUTRIGHT'].includes(variant)) {
    return <GroupedLinesBySport variant={variant} {...rest} />;
  }
  return <GroupedLinesSport variant={variant} {...rest} data-sentry-element="GroupedLinesSport" data-sentry-component="BaseGroupedLines" data-sentry-source-file="GroupedLines.tsx" />;
};
export const GroupedLines = memo(BaseGroupedLines);
GroupedLines.displayName = 'GroupedLines';